export const goodStrings = {
  good: {
    id: 'ID',
    name: 'Güterbezeichnung',
    nameColumn:
      'KWL-Nr. und Bezeichnung | AL-Nr. und Bezeichnung | Spezifikation',
    list: 'Güterliste',
    modified: 'Geändert',
    unit: 'Einheit',
    kwlNumber: 'KWL-Nummer',
    alNumber: 'AL-Nummer',
    specification: 'Spezifikation',
    listPosition: 'Listenposition',
  },
  entitySingular: 'Gut',
  entityPlural: 'Güter',
  messages: {
    archive: {
      success: (name: string) => `Gut "${name}" wurde archiviert`,
      error: 'Gut konnte nicht archiviert werden',
    },
    restore: {
      success: (name: string) => `Gut "${name}" wurde wiederhergestellt`,
      error: 'Gut konnte nicht wiederhergestellt werden',
    },
    deletion: {
      success: (name: string) => `Gut "${name}" wurde erfolgreich gelöscht`,
      error: 'Gut konnte nicht gelöscht werden',
    },
    update: {
      success: 'Gut erfolgreich aktualisiert',
      error: 'Gut konnte nicht aktualisiert werden',
    },
    create: {
      success: 'Gut erfolgreich erstellt',
      error: 'Gut konnte nicht erstellt werden',
    },
    import: {
      title: 'Güter aus Excel importieren',
      selectList: 'Güterliste zuweisen',
      selectListPlaceholder: 'Güterliste auswählen...',
      selectFile: 'Excel-Datei auswählen',
      chooseFile: 'Datei auswählen',
      noFileSelected: 'Keine Datei ausgewählt',
      rowsFound: (count: number) =>
        `${count} ${count === 1 ? 'Eintrag' : 'Einträge'} erkannt.`,
      action: (count: number) => `${count} Güter importieren`,
      success: (count: number) =>
        `${count} ${count === 1 ? 'Gut wurde' : 'Güter wurden'} erfolgreich importiert.`,
      error: 'Beim Import ist ein Fehler aufgetreten.',
    },
  },
};
